<template>
    <div>
        <div class="card-title">
            <b-button @click="$emit('back');" size="sm"><i class="fas fa-arrow-left"></i></b-button>
            {{notificationGroupName}}
        </div>
        <b-alert variant="success" :show="display_items.length == 0">
            No new notices
        </b-alert>
        <webix-ui v-if="showTable"
            :config="ui"
            :data="display_items"
        >
        </webix-ui>
    </div>
</template>

<script>
import _ from 'lodash';
import { sopClientAdminMethods, sopClientAdminState} from '@/state/helpers'
export default {
    data:() => ({
        showTable: false,
        ui:{
            view: 'datatable',
            id: window.webix.uid(),
            select: 'row',
            autoheight: true,
            fillspace: true,
            columns: [
                { id: 'sop_name', header: 'Name', fillspace: 1, sort: 'string'},
                { id: 'sop_code', header: 'Sop Code', fillspace: 1, sort: 'string'},
                { id: 'published_date', header: 'Published Date', fillspace: 1, sort: 'date'},
                { id: 'type', header: 'Type', fillspace: 0.4, sort: 'string', format(value){
                    switch(value){
                        case 'incoming_sop':{ return 'Incoming'; }
                        case 'distribute_sop':{ return 'Distribution Request'; }
                        case 'sign_sop':{ return 'Sign SOP'; }
                        default :{ return value; }
                    }
                }},
                { id: 'actions', header: 'Actions', fillspace: 0.8,
                    template:function(obj){
                        switch(obj.type){
                            case 'sign_sop':{
                                return `<button class="btn-primary btn-view btn-sm btn">View</button>`
                            }
                            case 'incoming_sop':{
                                return `<button class="btn-primary btn-view btn-sm btn">View</button>`
                            }
                            case 'distribute_sop':{
                                return `<button class="btn-primary btn-dist-view btn-sm btn">View</button>
                                `
                            }
                        }
                        
                    }
                },
            ],
            onClick:{
                'btn-view':function(a,b){
                    a.preventDefault();
                    let item = this.getItem(b);
                    console.log('DATA!!', item)
                    let el = this.$scope.$parent;
                    var data = {
                        group_id: item.sop_group_id,
                        id: item.sop_type_id,
                    };
                    if(item.type == 'sign_sop'){
                        el.setActiveJobInfo({
                            sign_mode: true,
                            job_id: item.actionable_id,
                            revision_id: item.revision_id
                        });
                        //el.$emit('selectedDocument', data);
                        el.$router.push({
                            name: 'document_view',
                            params: {
                                'document_id' : item.sop_type_id,
                            }
                        });
                    }
                    else if(item.type == 'incoming_sop'){
                        el.$emit('selectedDocumentNotification', data.id);
                    }
                },
                'btn-dist-view':function(a,b){
                    a.preventDefault();
                    let item = this.getItem(b);
                    let el = this.$scope.$parent;
                    el.$emit('viewDistributionRequest', item);
                    
                }
            },
            data: [],
        }
    }),
    props:{
        group_notifications:{}
    },
    components:{},
    computed:{
        ...sopClientAdminState,
        display_items(){
            if(this.group_notifications == null){
                return [];
            }
            else{
                let data = _.cloneDeep(this.group_notifications);
                //let groups = _.groupBy(data, 'type');
                
                return data;
                //return this.group_notifications;
            }
        },
        notificationGroupName(){
            let name = '';
            if(this.index == 0){
                name = "Document";
            }
            if(this.index == 1){
                name = "Facility";
            }
            if(this.index == 2){
                name = "Training";
            }
            if(this.index == 3){
                name = "Action";
            }
            name += ' Alerts';
            return name;
        }
    },
    watch:{
        group_notifications(){
            this.updateData();
        }
    },
    methods:{
        ...sopClientAdminMethods,
        updateData(){
            this.showTable = false;
            this.ui.data = this.display_items;
            this.$nextTick(()=>{
                this.showTable = true;
            });
        }
    },
    mounted(){
        this.updateData();
    },
}
</script>

<style>

</style>